import MapControl from './MapControl'

export default MapControl
